import React from "react";
import InteractiveMapPage from "../interactiveMapPage";
import airportImage from '../../3-assets/images/thailand/getting-there/airport.jpg'
import alliePlaneImage from '../../3-assets/images/thailand/getting-there/allie-plane.jpg'
import crewImage from '../../3-assets/images/thailand/getting-there/crew.jpg'
import phuketBenjiImage from '../../3-assets/images/thailand/phuket/me.jpg'
import phuketMarketImage from '../../3-assets/images/thailand/phuket/market.jpg'
import buddhaHikeImage from "../../3-assets/images/thailand/phuket/buddha-hike.jpg"
import buddhaGroupImage from "../../3-assets/images/thailand/phuket/buddha-group.jpg"
import phiPhiImage from "../../3-assets/images/thailand/phiphi/island.jpg";
import boatImage from "../../3-assets/images/thailand/phiphi/boat.jpg";
import springImage from "../../3-assets/images/thailand/pai/spring.jpg";
import springFeetImage from "../../3-assets/images/thailand/pai/spring-feet.jpg";
import canyonImage from "../../3-assets/images/thailand/pai/canyon.jpg";
import caveImage from "../../3-assets/images/thailand/pai/cave.jpg";
import waterfallImage from "../../3-assets/images/thailand/pai/waterfall.jpg";
import mojitoImage from "../../3-assets/images/thailand/pai/mojito.jpg";
import jengaBarImage from "../../3-assets/images/thailand/pai/jenga-bar.jpg";
import mopedImage from "../../3-assets/images/thailand/pai/mopeds.jpg";
import paintBarImage from "../../3-assets/images/thailand/pai/paint-bar.jpg";
import canyonGroupImage from "../../3-assets/images/thailand/pai/canyon-group.jpg";
import buddhaImage from "../../3-assets/images/thailand/pai/buddha.jpg";

const events = [
  {
    images: [crewImage],
    paragraphs: [
      "Every backpacking blog preaches the virtues of traveling in small groups. Even better, do it alone. I felt it’d be fun to start with a small crew, so I cast a wide net, expecting only one or two would stick after googling flight costs.",
      "That turned into a 7-person group chat, 7 plane tickets, and a bunch of hostel reservations.",
      "My excitement to travel the world with no real responsibilities morphed into nervousness about traveling with a big group. It didn’t ease any nerves when I told any of my friends that the group was entirely girls, let alone graduates from Michigan, Ohio State, and Indiana — aggressively rival schools.",
      "My female friends reacted as if I had said I planned on traveling with an enthusiastic family of skunks. My guy friends who did not have sisters were much more supportive. The guys that did were very not.",
    ],
    location: {
      name: "The Crew",
      coordinates: {
        lat: 42.2711,
        lng: -89.094
      }
    }
  },
  {
    images: [airportImage, alliePlaneImage],
    paragraphs: [
      "Three of us traveled to Asia a few days early to see southern Thailand before meeting up with the others in Vietnam.",
      "Equipped with enough chocolate cookies in zip-loc bags from Allie’s mom to cause a security guard to double-take, we took three long flights over 27 hours.",
      "I’m not sure what credit card Allie used, but it got us in to every airport VIP lounge with unlimited free food.",
      "Scrabble was played, played again, and then some more."
    ],
    location: {
      name: "Getting There",
      coordinates: {
        lat: 40.7128,
        lng: -74.006
      }
    }
  },
  {
    images: [phuketBenjiImage, phuketMarketImage],
    paragraphs: [
      "Phuket is popular partly because it’s developed airport is so easy to get too. It felt a little too popular, looking like a Thai version of Mardis Gras at times. We stayed outside of the main party area at the Sleepy Station Hostel, which describes itself as NOT a party hostel.",
      "We only stayed here for two nights, but within a day we had made friends with most people in the hostel. Notably, Idaho-man, an eccentric twenty-something from Idaho wearing a fully unbuttoned button down, trunks, and swigging a handle of whiskey, brought a bunch of us to the International Bartending School (and hostel) for a rooftop pool party.",
      "After, we checked out a night market with some of the friends we made at the bartending school. These guys were way more hardcore of travelers than us. We thought $3 for a full meal was a great deal, but for them, Thailand was more expensive than other countries. One guy from Germany would cop leftover food left by other tourists at the market. "
    ],
    location: {
      name: "Phuket",
      coordinates: {
        lat: 7.821354,
        lng: 98.301932
      }
    }
  },
  {
    images: [buddhaHikeImage, buddhaGroupImage],
    paragraphs: [
      "Our first full day, we decided to hike up a mountain to see the famous “Big Buddha” statue. Most people get driven to the viewpoint. Others would get driven to the start of the trail, and hike up. The owner of our hostel told us if we instead just stayed on this road, we could walk straight there, but he’d never tried. That sounded easy enough, so we started walking.",
      "We walked 15 miles.",
      "It felt a bit weird hugging major highways and trying to ask directions in places I’m pretty sure few tourists have ever gone, but google maps said this was the way. (The sporadic, torrential rainstorms didn’t help). It sure felt good to finally reach the summit, until I realized I left my camera battery at the hostel."
    ],
    location: {
      name: "Big Buddha",
      coordinates: {
        lat: 7.8276,
        lng: 98.3128
      }
    }
  },
  {
    images: [phiPhiImage, boatImage],
    paragraphs: [
      "We only stayed at Phi Phi for one night. You get there by ferry, and if you’re lucky, your boat will have free coffee and tea. After our crazy hiking, we were very ready to have a chill day on the beach.",
      "The beaches were great, but the rest of Phi Phi felt very touristy. The tackiness and steeper prices rubbed us the wrong way, so I wouldn’t spend more than a day or two there if you really want to check out the islands.",
      "Every hostel there is a party hostel, so there’s a chance you’ll wake up at 3am to the sound of someone puking."
    ],
    location: {
      name: "Phi Phi",
      coordinates: {
        lat: 7.7407,
        lng: 98.7784
      }
    }
  },
  {
    images: [],
    paragraphs: [
      "I went to Vietnam and Bali before stopping in Thailand again on my way to Laos, but I did get to spend a night in Chiang Mai.",
      "Chiang Mai’s gargantuan night market is easily the biggest one I’ve ever seen. Among other things, I tried steamed crab, squid-on-a-stick, and scorpion-on-a-stick (crunchier than you’d expect).",
      "I both met up with friends from school that I knew were in Chiang Mai, and ran into multiple groups of them totally by chance. Later we all went out to the bars, which was more like a crazy block party than anything else."
    ],
    location: {
      name: "Chiang Mai",
      coordinates: {
        lat: 18.7061,
        lng: 98.9817
      }
    }
  },
  {
    images: [mojitoImage, jengaBarImage, paintBarImage, mopedImage],
    paragraphs: [
      "I wasn’t recommended to go to Pai. I was told I NEED to go to Pai and  keep my schedule flexible, since It’s common a 2 day stop in Pai turns into two weeks. It’s also why people call it the “Pai Hole.”",
      "Pai is different from any other town I’ve gone too. It had been described to me as a hippy town surrounded in nature. That didn’t feel like it hit the mark. It is much more naturey than the big Thailand cities, but way more city-like than rural towns in Bali, Vietnam, or Laos. I think a better way to describe it is the kum-ba-yah feel you have from summer camp, plus shrooms.",
      "Everything is chill in Pai. Even the great night scene is less a rager and more talk-with-other-people. The restaurant scene is fantastic and  aesthetically instagrammable while still feeling genuine.",
      "You’ll see a lot of foods prefaced with “happy,” like a happy-shake or happy-pizza. This is lingo for shrooms, marijuana, or some other drug.",
      "There’s a bunch of great things to see, but you pretty much need to rent a moped. Be warned, the police stations is sandwiched right between where you rent mopeds and the only gas station. The cops will wait there and ticket drivers without an international driving license (which is everyone) until they have too many people to deal with in the station.",
      "I got the feeling the moped-dealers were in on this, since we were all given near-empty bikes and had to spend an hour in the station getting fines. The ticket you get serves as a 3-day permit, so you can moped without worry of getting another ticket. It’s bull-shit."
    ],
    location: {
      name: "Pai",
      coordinates: {
        lat: 19.3582,
        lng: 98.4405
      }
    }
  },
  {
    images: [buddhaImage],
    paragraphs: [
      "This is an easy, 15 minute stop right outside town. Just bring cloths to cover your shoulders/legs, especially if you’re a girl. We had use our raincoats and towels to cover some of our crew."
    ],
    location: {
      name: "White Buddha",
      coordinates: {
        lat: 19.350421,
        lng: 98.45618
      }
    }
  },
  {
    images: [waterfallImage],
    paragraphs: [
      "This was a pretty easy and short hike. The waterfall was pretty wimpy, but the rock structures were interesting. The water is real nasty and smells, but one guy we met decided to take a swim. I hope he’s alright."
    ],
    location: {
      name: "Pam Bok Waterfall",
      coordinates: {
        lat: 19.320789,
        lng: 98.405285
      }
    }
  },
  {
    images: [springImage, springFeetImage],
    paragraphs: [
      "Sai Ngam was a great way to end the day. This natural spring was pretty far from town, but the drive was absolutely beautiful. The water is warm, but not hot-tub-level hot. Highly recommend checking out."
    ],
    location: {
      name: "Sai Ngam Hot Spring",
      coordinates: {
        lat: 19.459272,
        lng: 98.379975
      }
    }
  },
  {
    images: [canyonImage, canyonGroupImage],
    paragraphs: [
      "Lots of backpackers come here at the end of the day to watch the sunset. It’s good for either drinking a coconut and chilling, or maze-ing through the canyon. Some check it out once, while others come out each sunset."
    ],
    location: {
      name: "Pai Canyon",
      coordinates: {
        lat: 19.306506,
        lng: 98.452495
      }
    }
  },
  {
    images: [caveImage],
    paragraphs: [
      "Tham Lod is far. We moped-ed there, and it was 90 minutes of the zig-zag-iest roads I’ve ever seen. The constant turns up and down the mountain were pretty scary to drive on, and trying to pass by a slow car requires some guts.",
      "You need a tour guide to go in the cave. This felt like a scam at first, but was 100% necessary. Navigating that place would’ve been a nightmare on our own. The hike was great, and you’ll see thousands of birds and bats flying everywhere, especially near the entrance. I’d recommend doing the boat tour through the waterway of the cave too."
    ],
    location: {
      name: "Tham Lod Caves",
      coordinates: {
        lat: 19.568576,
        lng: 98.279731
      }
    }
  }
];

export default function Thailand() {
  return <InteractiveMapPage events={events} countryName="Thailand" />;
}
